import { createAsyncThunk } from '@reduxjs/toolkit';
import { DELETE_PREVIEW_IMAGE } from '@custom/constant';

const deletePreviewImage = createAsyncThunk('deletePreviewImage', async (payload: Object) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    const response = await fetch(DELETE_PREVIEW_IMAGE, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP status ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    throw new Error(`Error uploading file: ${error.message}`);
  }
});

export default deletePreviewImage;
